import axios from 'axios';
import { createHeaders } from './headerUtils';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const auth0Service = {
  getUserBlocks: async (email) => {
    const headers = createHeaders();
    const response = await axios.get(`${BASE_URL}/auth0/user-blocks`, {
      headers,
      params: { email },
    });
    return response.data;
  },

  removeUserBlock: async (email) => {
    const headers = createHeaders();
    const response = await axios.delete(`${BASE_URL}/auth0/user-blocks`, {
      headers,
      params: { email },
    });
    return response.data;
  },
};
